import {
  LOGIN,
  LOGOUT,
  INIT_LOGIN,
  LOGIN_GET_VERIFICATION,
} from "./constants.js"

//初始化登录状态
export const initLoginAction = (token) => ({
  type: INIT_LOGIN,
  payload: token,
})

//登录
export const loginAction = (promise) => ({
  type: LOGIN,
  payload: promise,
})

//退出登录
export const logoutAction = () => ({
  type: LOGOUT,
})

//获取验证码
export const loginGetVerification = (promise) => ({
  type: LOGIN_GET_VERIFICATION,
  payload: promise,
})
